import React from 'react';
import { Image, ImageWrap, ResponsivePicture } from '../../../ui';

const largeImage =
	'//www.charlottefive.com/wp-content/uploads/2018/02/skyline-charlotte-nc-charlottefive-e1522257298575.jpg';

const smallImage =
	'//lh3.googleusercontent.com/rJEdTdc3WpyFDvgdLSWoYgd5l3htsIMtZy4f6ZW-X1TGjkKfHgFf4so5yOrsURefixRR6Vq3G5q9o1plBpeGKowygsidgTUCH3inhQ=w400';

export const Images = () => (
	<>
		<h2 id="images">Images</h2>

		<Image alt="Some large image" src={largeImage} />
		<Image alt="Some small image" src={smallImage} />

		<h3>Responsive Images</h3>

		<ImageWrap>
			<ResponsivePicture
				alt="Some responsive image"
				source={[largeImage, { mobileXL: smallImage }]}
			/>
		</ImageWrap>
	</>
);
